/**
 * Who the signed-in person is, for UI gates — the two facts ported screens ask.
 *
 * `useUserId` is the session's own subject (the platform token's `sub`, stored
 * by @fiveox/shell) — what maker-checker screens compare `resolved_by`
 * against. `roleLabelOf` mirrors `compat.role_label` on the service EXACTLY
 * (settings.can_update → admin, review.can_update → reviewer, else preparer):
 * the predecessor's reason-code taxonomy speaks in role names
 * (`resolver_roles`), and the service judges submissions with the same mapping
 * — deriving it from the SAME evaluation the API enforces with keeps the UI
 * gate from drifting (FiveOX ADR-0029: both levels, always).
 */
import type { Evaluation } from './access'
import { session } from './session'

export function useUserId(): string | null {
  return session.useSession()?.userId ?? null
}

export type RoleLabel = 'admin' | 'reviewer' | 'preparer'

export function roleLabelOf(evaluation: Evaluation | null): RoleLabel {
  if (evaluation?.permissions['settings']?.can_update) return 'admin'
  if (evaluation?.permissions['review']?.can_update) return 'reviewer'
  return 'preparer'
}
